import { format, subDays, addDays, parseISO } from "date-fns";
import { FaChevronLeft, FaChevronRight, FaCalendarAlt } from "react-icons/fa";

const ArrowButton = ({ direction, onClick, disabled = false }) => {
  const isPrev = direction === "prev";
  const Icon = isPrev ? FaChevronLeft : FaChevronRight;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={`Go to ${isPrev ? 'previous' : 'next'} day`}
      className={`p-2 rounded-lg ${
        disabled
          ? "text-gray-300 cursor-not-allowed"
          : "hover:bg-gray-100 text-gray-600"
      }`}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
};

export default function DateNavigator({ selectedDate, onDateChange }) {
  const dateObj = parseISO(selectedDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const handleDateChange = (direction) => {
    const newDate =
      direction === "prev" ? subDays(dateObj, 1) : addDays(dateObj, 1);

    onDateChange(format(newDate, "yyyy-MM-dd"));
  };

  const handleInputDateChange = (e) => {
    onDateChange(e.target.value);
  };

  return (
    <div className="sticky top-0 z-10">
      <div className="flex items-center justify-between bg-white rounded-xl shadow-sm p-4 border border-gray-100">
        <div className="flex gap-1">
          <ArrowButton
            direction="prev"
            onClick={() => handleDateChange("prev")}
          />
        </div>

        <div className="flex flex-row items-center gap-2">
          <div className="relative flex items-center">
            <label htmlFor="date-input" className="cursor-pointer">
              <FaCalendarAlt className="text-gray-500 w-5 h-5" />
            </label>
            <input
              id="date-input"
              type="date"
              value={selectedDate}
              onChange={handleInputDateChange}
              max={format(today, "yyyy-MM-dd")}
              className="absolute opacity-0 w-5 h-5 cursor-pointer"
            />
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">
              {format(dateObj, "EEEE d MMMM yyyy")}
            </h2>
          </div>
        </div>

        <div className="flex gap-1">
          <ArrowButton
            direction="next"
            onClick={() => handleDateChange("next")}
            disabled={dateObj >= today}
          />
        </div>
      </div>
    </div>
  );
}
